import React, { useState, useEffect } from 'react';
import './css/repasoAutomatico.css';

// Componentes
import InfoPanel from './components/InfoPanel';
import TabPanel from './components/TabPanel';
import TabContentEstaSemana from './components/TabContentEstaSemana';
import TabContentTodosTests from './components/TabContentTodosTests';
import TabContentPlanificacion from './components/TabContentPlanificacion';
import ExplicativoPanel from './components/ExplicativoPanel';

const RepasoInformatica = ({ 
  testSemanales, 
  estadoAlumno, 
  inicioNumeracion, 
  finNumeracion, 
  handleOnClic 
}) => {
  const [temaActual, setTemaActual] = useState(null);
  const [semanaRepaso, setSemanaRepaso] = useState(0);
  const [vueltasCompletadas, setVueltasCompletadas] = useState(0);
  const [testsDestacados, setTestsDestacados] = useState([]);
  const [testsDisponibles, setTestsDisponibles] = useState([]);
  const [activeTab, setActiveTab] = useState("esta-semana");
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredTests, setFilteredTests] = useState([]);
  
  // Nuevos estados para la categorización
  const [testsRepaso, setTestsRepaso] = useState([]);
  const [testsGenerales, setTestsGenerales] = useState([]);

  // Configuración de las pestañas
  const tabs = [
    { id: "esta-semana", label: "Esta semana", icon: "fas fa-star" },
    { id: "todos-tests", label: "Todos los tests", icon: "fas fa-list-alt" },
    { id: "planificacion", label: "Planificación", icon: "fas fa-calendar-alt" }
  ];

  useEffect(() => {
    if (estadoAlumno && testSemanales) {
      console.log('=== ACTUALIZACIÓN DE ESTADO REPASO ===');
      console.log('Estado del alumno:', estadoAlumno);
      console.log('Total tests semanales recibidos:', testSemanales.length);
      
      // Detectar si es un administrador por la falta de estructura completa
      const isAdmin = estadoAlumno.mesesPagados >= 6 && 
                    (!estadoAlumno.practicaPrincipal || 
                     typeof estadoAlumno.practicaPrincipal === 'string');
      
      console.log(`Es usuario administrador: ${isAdmin}`);
      
      // Para alumnos regulares con estructura completa
      if (!isAdmin && estadoAlumno.mesesPagados >= 6 && estadoAlumno.practicaPrincipal && 
          estadoAlumno.practicaPrincipal.modoRepaso) {
        console.log('Aplicando valores directamente desde estadoAlumno:');
        const semana = estadoAlumno.practicaPrincipal.semanaActual;
        const vueltas = estadoAlumno.practicaPrincipal.vueltasCompletadas;
        // Para el tema, usamos la misma lógica: si semana es 0, tema es 1, de lo contrario semana+1
        const tema = semana === 0 ? 1 : semana + 1;
        
        console.log(`- Semana: ${semana}, Tema: ${tema}, Vueltas: ${vueltas}`);
        setSemanaRepaso(semana);
        setTemaActual(tema);
        setVueltasCompletadas(vueltas);
        
        // En lugar de usar setTimeout, pasamos los valores actualizados directamente
        // a filtrarTestsRepaso para evitar problemas de asincronía
        const testsCopy = [...testSemanales];
        const categorizados = categorizarTests(testsCopy);
        filtrarTestsRepaso(categorizados, tema);
      } else {
        // Para administradores o cualquier otro caso, calculamos basado en fechas
        calcularEstadoRepaso();
        
        // Usamos un timeout para dar tiempo a que se actualicen los estados
        setTimeout(() => {
          // Sabemos ahora que temaActual no estará actualizado todavía,
          // por lo que necesitamos capturar el valor recalculado directamente
          const tema = calcularTemaActual();
          console.log(`Tema recalculado para filtrado: ${tema}`);
          filtrarTestsRepaso(null, tema);
        }, 100);
      }
      
      console.log('Tema actual:', temaActual);
      console.log('Semana de repaso:', semanaRepaso);
      console.log('Vueltas completadas:', vueltasCompletadas);
      console.log('=== FIN ACTUALIZACIÓN DE ESTADO ===\n');
    }
  }, [estadoAlumno, testSemanales]);

  useEffect(() => {
    if (testsDisponibles.length > 0) {
      console.log(`=== FILTRADO POR BÚSQUEDA: "${searchTerm}" ===`);
      filtrarPorBusqueda();
      console.log(`Resultados totales: ${filteredTests.length} tests`);
      console.log('=== FIN FILTRADO POR BÚSQUEDA ===\n');
    }
  }, [searchTerm, testsDisponibles]);

  // Calcula la semana actual de repaso y el número de vueltas completadas
  const calcularEstadoRepaso = () => {
    if (estadoAlumno && estadoAlumno.mesesPagados >= 6) {
      console.log('Cálculo de la semana de repaso:');
      
      // Detectar si es administrador
      const isAdmin = !estadoAlumno.practicaPrincipal || 
                    typeof estadoAlumno.practicaPrincipal === 'string';
      
      // Usar la API nativa de JavaScript para fechas
      const fechaActual = new Date();
      let mesesPagados;
      
      if (isAdmin) {
        // Para administradores, calculamos los meses desde noviembre 2024
        const fechaInicioNoviembre = new Date(2024, 10, 1); // Noviembre es mes 10 (0-indexado)
        const mesesTranscurridos = (fechaActual.getMonth() - fechaInicioNoviembre.getMonth()) + 
                                 12 * (fechaActual.getFullYear() - fechaInicioNoviembre.getFullYear());
        // Sumamos 1 porque noviembre es el mes 1
        mesesPagados = mesesTranscurridos + 1;
        
        console.log(`Calculando meses para administrador desde Nov 2024: ${mesesPagados} meses pagados`);
      } else {
        // Para usuarios normales, tomamos los meses pagados de su estado
        mesesPagados = estadoAlumno.mesesPagados;
        console.log(`Usuario normal con ${mesesPagados} meses pagados`);
      }
      
      // Calcular la fecha de inicio del repaso (inicio mes 6)
      // Para esto, retrocedemos (mesesPagados - 6) meses desde la fecha actual
      const fechaInicioRepaso = new Date(fechaActual.getFullYear(), fechaActual.getMonth() - (mesesPagados - 6), 1);
      
      // Calcular la diferencia en milisegundos
      const diferenciaMs = fechaActual - fechaInicioRepaso;
      const diasTranscurridos = Math.floor(diferenciaMs / (24 * 60 * 60 * 1000));
      
      // Convertir milisegundos a semanas (1 semana = 7 días = 604800000 ms)
      const semanasTranscurridas = Math.floor(diferenciaMs / (7 * 24 * 60 * 60 * 1000));
      
      console.log(`- Meses pagados: ${mesesPagados}`);
      console.log(`- Fecha inicio repaso: ${fechaInicioRepaso.toISOString().split('T')[0]}`);
      console.log(`- Fecha actual: ${fechaActual.toISOString().split('T')[0]}`);
      console.log(`- Días transcurridos: ${diasTranscurridos}`);
      console.log(`- Semanas transcurridas: ${semanasTranscurridas}`);
      
      // Calcular el tema actual (de 0 a 5, ciclo de 6 semanas)
      const semanaActual = semanasTranscurridas % 6;
      
      // Calcular vueltas completadas (cada 6 semanas)
      const vueltas = Math.floor(semanasTranscurridas / 6);
      
      console.log(`- Semana posición en ciclo de 6: ${semanaActual}`);
      console.log(`- Vueltas completadas: ${vueltas}`);
      
      // La semana se almacena como posición en el ciclo (0-5) pero se muestra como 1-6
      setSemanaRepaso(semanaActual);
      setVueltasCompletadas(vueltas);
      
      // Establecer el tema actual basado en la semana
      // El tema siempre es semanaActual+1, o 6 si semanaActual es 5
      // Si semanaActual es 0, estamos en la 1ª semana = tema 1
      const temaCalculado = semanaActual >= 5 ? 6 : semanaActual + 1;
      console.log(`- Tema calculado: ${temaCalculado}`);
      setTemaActual(temaCalculado);
    }
  };

  // Función para categorizar los tests
  const categorizarTests = (testsDisponibles) => {
    console.log('=== INICIO CATEGORIZACIÓN DE TESTS ===');
    console.log('Tests disponibles iniciales:', testsDisponibles);
    
    // Detectar si es administrador
    const isAdmin = !estadoAlumno.practicaPrincipal || 
                  typeof estadoAlumno.practicaPrincipal === 'string';
    
    // Determinar los meses pagados reales para la categorización
    let mesesPagados;
    
    if (isAdmin) {
      // Para administradores, calculamos los meses desde noviembre 2024
      const fechaActual = new Date();
      const fechaInicioNoviembre = new Date(2024, 10, 1); // Noviembre es mes 10 (0-indexado)
      const mesesTranscurridos = (fechaActual.getMonth() - fechaInicioNoviembre.getMonth()) + 
                              12 * (fechaActual.getFullYear() - fechaInicioNoviembre.getFullYear());
      // Sumamos 1 porque noviembre es el mes 1
      mesesPagados = mesesTranscurridos + 1;
      console.log(`Meses pagados calculados para administrador: ${mesesPagados}`);
    } else {
      mesesPagados = estadoAlumno.mesesPagados;
      console.log(`Meses pagados por el alumno: ${mesesPagados}`);
    }
    
    // Inicializar arrays para cada categoría
    const testsRepasoTemp = [];
    const testsGeneralesTemp = [];
    
    // Calcular el número de vuelta actual
    const vueltaActual = mesesPagados >= 6 ? 
      Math.ceil((mesesPagados - 5) / 6) : 0;
      
    console.log(`Vuelta actual del ciclo de repaso: ${vueltaActual}`);
    
    // Contador global de tests de repaso para calcular las vueltas correctamente
    let contadorTestsRepaso = 0;
    
    // Iterar sobre todos los meses a partir del 6
    for (let mes = 6; mes <= mesesPagados; mes++) {
      console.log(`\nProcesando mes ${mes}:`);
      // Calcular el índice de inicio para los tests de este mes
      const indiceInicio = (mes - 6) * 8;
      console.log(`Índice de inicio para este mes: ${indiceInicio}`);
      
      // Los primeros 4 tests del mes son para repaso específico
      for (let i = 0; i < 4; i++) {
        const indiceTest = indiceInicio + i;
        if (indiceTest < testsDisponibles.length) {
          // Calcular el tema basándose en el índice global del test de repaso
          // Cada mes tiene 4 tests de repaso, así que el índice global es:
          const indiceGlobalRepaso = ((mes - 6) * 4) + i;
          // El tema va del 1 al 6 en ciclo continuo
          const temaRepaso = (indiceGlobalRepaso % 6) + 1;
          
          // Calcular la vuelta basada en el contador de tests de repaso
          // Cada 6 tests de repaso completamos una vuelta
          const vueltaTest = Math.floor(contadorTestsRepaso / 6) + 1;
          
          // Actualizar el objeto test con los metadatos necesarios
          const testUpdated = {
            ...testsDisponibles[indiceTest],
            tema: temaRepaso,
            tipo: 'repaso',
            mes_desbloqueo: mes, // Añadimos el mes de desbloqueo para referencia
            indice_mes: i, // Posición dentro del mes (0-3 para repaso)
            vuelta: vueltaTest // Vuelta del ciclo de repaso
          };
          console.log(`Test repaso: #${testUpdated.numero_test}, Tema: ${temaRepaso}, Mes: ${mes}, Vuelta: ${vueltaTest}`);
          testsRepasoTemp.push(testUpdated);
          testsDisponibles[indiceTest] = testUpdated;
          
          // Incrementar el contador de tests de repaso
          contadorTestsRepaso++;
        } else {
          console.log(`Índice ${indiceTest} fuera de rango. No hay suficientes tests.`);
        }
      }
      
      // Calcular la vuelta para los tests generales del mes actual
      // Usar la vuelta del último test de repaso procesado en este mes
      const vueltaGenerales = Math.floor((contadorTestsRepaso - 1) / 6) + 1;
      
      // Los siguientes 4 tests son generales
      for (let i = 4; i < 8; i++) {
        const indiceTest = indiceInicio + i;
        if (indiceTest < testsDisponibles.length) {
          const testUpdated = {
            ...testsDisponibles[indiceTest],
            tipo: 'general',
            mes_desbloqueo: mes, // Añadimos el mes de desbloqueo para referencia
            indice_mes: i, // Posición dentro del mes (4-7 para general)
            vuelta: vueltaGenerales // Vuelta del ciclo de repaso
          };
          console.log(`Test general: #${testUpdated.numero_test}, Posición: ${i-3}/4, Mes: ${mes}, Vuelta: ${vueltaGenerales}`);
          testsGeneralesTemp.push(testUpdated);
          testsDisponibles[indiceTest] = testUpdated;
        } else {
          console.log(`Índice ${indiceTest} fuera de rango. No hay suficientes tests.`);
        }
      }
    }
    
    // Ordenar los tests de repaso por tema para una mejor organización
    testsRepasoTemp.sort((a, b) => a.tema - b.tema);
    
    console.log('\n=== RESUMEN DE CATEGORIZACIÓN ===');
    console.log(`Total tests de repaso: ${testsRepasoTemp.length}`);
    console.log(`Total tests generales: ${testsGeneralesTemp.length}`);
    console.log(`Total tests disponibles: ${testsDisponibles.length}`);
    
    // Distribución de tests de repaso por tema
    const distribucionPorTema = {};
    testsRepasoTemp.forEach(test => {
      distribucionPorTema[test.tema] = (distribucionPorTema[test.tema] || 0) + 1;
    });
    console.log('Distribución de tests de repaso por tema:', distribucionPorTema);
    
    // Distribución de tests por vuelta
    const distribucionPorVuelta = {};
    [...testsRepasoTemp, ...testsGeneralesTemp].forEach(test => {
      if (!distribucionPorVuelta[test.vuelta]) {
        distribucionPorVuelta[test.vuelta] = { repaso: 0, general: 0 };
      }
      if (test.tipo === 'repaso') {
        distribucionPorVuelta[test.vuelta].repaso++;
      } else {
        distribucionPorVuelta[test.vuelta].general++;
      }
    });
    console.log('Distribución de tests por vuelta:', distribucionPorVuelta);
    console.log('=== FIN CATEGORIZACIÓN DE TESTS ===\n');
    
    return { 
      testsRepaso: testsRepasoTemp, 
      testsGenerales: testsGeneralesTemp, 
      todosLosTests: testsDisponibles 
    };
  };

  // Filtra los tests según el modo de repaso
  const filtrarTestsRepaso = (categorizados = null, temaPasado = null) => {
    if (!testSemanales || testSemanales.length === 0) return;

    // Si no se pasan tests ya categorizados, hacemos la categorización
    let testsRepasoCat, testsGeneralesCat, todosLosTestsCat;
    if (!categorizados) {
      const testsCopy = [...testSemanales];
      const resultado = categorizarTests(testsCopy);
      testsRepasoCat = resultado.testsRepaso;
      testsGeneralesCat = resultado.testsGenerales;
      todosLosTestsCat = resultado.todosLosTests;
    } else {
      testsRepasoCat = categorizados.testsRepaso;
      testsGeneralesCat = categorizados.testsGenerales;
      todosLosTestsCat = categorizados.todosLosTests;
    }
    
    // Actualizar estados
    setTestsRepaso(testsRepasoCat);
    setTestsGenerales(testsGeneralesCat);
    setTestsDisponibles(todosLosTestsCat);
    setFilteredTests(todosLosTestsCat);
    
    // Usamos el tema pasado como parámetro si está disponible, o el temaActual del estado
    const temaParaFiltrar = temaPasado !== null ? temaPasado : temaActual;
    console.log(`Filtrando tests destacados para Tema: ${temaParaFiltrar}`);
    
    // Tests destacados: los tests correspondientes al tema actual
    const testsDelTema = testsRepasoCat.filter(test => {
      console.log(`Comparando test.tema (${test.tema}) con temaParaFiltrar (${temaParaFiltrar})`);
      // Aseguramos que la comparación se haga con números
      return parseInt(test.tema) === parseInt(temaParaFiltrar);
    });
    
    console.log(`Tests encontrados para el tema ${temaParaFiltrar}: ${testsDelTema.length}`);
    
    // Limitamos a 2 tests destacados por tema
    const destacados = testsDelTema.slice(0, 2);
    console.log(`Tests destacados finales: ${destacados.length}`);
    setTestsDestacados(destacados);
  };

  // Calcula el tema actual basado en la fecha actual
  const calcularTemaActual = () => {
    // Detectar si es administrador
    const isAdmin = !estadoAlumno.practicaPrincipal || 
                  typeof estadoAlumno.practicaPrincipal === 'string';
    
    // Usar la API nativa de JavaScript para fechas
    const fechaActual = new Date();
    let mesesPagados;
    
    if (isAdmin) {
      // Para administradores, calculamos los meses desde noviembre 2024
      const fechaInicioNoviembre = new Date(2024, 10, 1); // Noviembre es mes 10 (0-indexado)
      const mesesTranscurridos = (fechaActual.getMonth() - fechaInicioNoviembre.getMonth()) + 
                               12 * (fechaActual.getFullYear() - fechaInicioNoviembre.getFullYear());
      // Sumamos 1 porque noviembre es el mes 1
      mesesPagados = mesesTranscurridos + 1;
      
      console.log(`calcularTemaActual: Admin desde Nov 2024: ${mesesPagados} meses pagados`);
    } else {
      // Para usuarios normales, tomamos los meses pagados de su estado
      mesesPagados = estadoAlumno.mesesPagados;
      console.log(`calcularTemaActual: Usuario normal con ${mesesPagados} meses pagados`);
    }
    
    // Calcular la fecha de inicio del repaso (inicio mes 6)
    // Para esto, retrocedemos (mesesPagados - 6) meses desde la fecha actual
    const fechaInicioRepaso = new Date(fechaActual.getFullYear(), fechaActual.getMonth() - (mesesPagados - 6), 1);
    
    // Calcular la diferencia en milisegundos
    const diferenciaMs = fechaActual - fechaInicioRepaso;
    const diasTranscurridos = Math.floor(diferenciaMs / (24 * 60 * 60 * 1000));
    
    // Convertir milisegundos a semanas (1 semana = 7 días = 604800000 ms)
    const semanasTranscurridas = Math.floor(diferenciaMs / (7 * 24 * 60 * 60 * 1000));
    
    // Calcular el tema actual (de 0 a 5, ciclo de 6 semanas)
    const semanaActual = semanasTranscurridas % 6;
    
    // El tema siempre es semanaActual+1, o 6 si semanaActual es 5
    // Si semanaActual es 0, estamos en la 1ª semana = tema 1
    const temaCalculado = semanaActual >= 5 ? 6 : semanaActual + 1;
    
    console.log(`calcularTemaActual: Meses pagados: ${mesesPagados}, ` +
                `Fecha inicio repaso: ${fechaInicioRepaso.toISOString().split('T')[0]}, ` +
                `Semanas: ${semanasTranscurridas}, ` +
                `Posición en ciclo: ${semanaActual}, Tema: ${temaCalculado}`);
    
    return temaCalculado;
  };

  // Función para filtrar tests por búsqueda
  const filtrarPorBusqueda = () => {
    if (!searchTerm) {
      setFilteredTests(testsDisponibles);
      return;
    }
    
    const termino = searchTerm.toLowerCase();
    const resultados = testsDisponibles.filter(test => 
      (test.numero_test && test.numero_test.toString().includes(termino)) || 
      (test.tema && test.tema.toString().includes(termino)) ||
      (test.descripcion && test.descripcion.toLowerCase().includes(termino))
    );
    
    setFilteredTests(resultados);
  };

  // Maneja la descarga de tests y soluciones
  const handleDescargarTest = (test) => {
    // Validar que test tenga todas las propiedades necesarias
    if (!test || !test.numero_test) {
      swal('Error', 'Información del test no disponible', 'error');
      return;
    }

    const linkDescarga1 = test.link_test;
    const nameDes1 = `Test ${test.numero_test}.pdf`;

    const linkDescarga2 = test.link_soluciones;
    const nameDes2 = `Respuestas-Test${test.numero_test}.pdf`;

    // Verificar que al menos el link del test exista
    if (!linkDescarga1) {
      swal('Error', 'El enlace de descarga del test no está disponible', 'error');
      return;
    }

    // Verificar que el link del test tenga el formato esperado (que contenga '..')
    if (!linkDescarga1.includes('..')) {
      swal('Error', 'Formato de enlace incorrecto, por favor reporte este problema', 'error');
      return;
    }

    // Para tests de repaso, solo descargamos el test (no las soluciones)
    const esTestRepaso = test.tipo === 'repaso';
    
    // Determinar si hay soluciones disponibles y si debemos descargarlas
    const tieneSoluciones = linkDescarga2 && linkDescarga2 !== null && linkDescarga2.includes('..');
    const debeDescargarSoluciones = tieneSoluciones && !esTestRepaso;
    
    // Mostrar mensaje apropiado según el tipo de test
    if (esTestRepaso) {
      swal('Descarga en proceso', 'Se descargará el test de repaso. Si no inicia la descarga en 30 segundos vuelva a intentarlo.', 'info');
    } else if (debeDescargarSoluciones) {
      swal('Descargas en proceso', 'Si no inicia la descarga en 30 segundos vuelva a intentarlo.', 'info');
    } else {
      swal('Descarga en proceso', 'Este test no incluye soluciones. Si no inicia la descarga en 30 segundos vuelva a intentarlo.', 'info');
    }

    try {
      // Descarga el test
      let pathFile = 'public' + linkDescarga1.split('..')[1];
      let url = new URL("https://oposiciones-justicia.es/api/file/downloadFile?route=" + pathFile);
      
      fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        responseType: 'blob'
      }).then(res => {
        if (res.status >= 400) { throw new Error("Bad res from server"); }
        return res.blob();
      }).then(blob => {
        saveAs(blob, nameDes1);
      }).catch(function (err) {
        console.log(err);
        swal('Link de descarga no válido', `Error en el archivo: ${nameDes1}, repórtelo gracias.`, 'info');
      });

      // Solo descarga las soluciones si están disponibles y NO es un test de repaso
      if (debeDescargarSoluciones) {
        let pathFile2 = 'public' + linkDescarga2.split('..')[1];
        let url2 = new URL("https://oposiciones-justicia.es/api/file/downloadFile?route=" + pathFile2);
        
        fetch(url2, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
          responseType: 'blob'
        }).then(res => {
          if (res.status >= 400) { throw new Error("Bad res from server"); }
          return res.blob();
        }).then(blob => {
          saveAs(blob, nameDes2);
        }).catch(function (err) {
          console.log(err);
          swal('Link de descarga no válido', `Error en el archivo: ${nameDes2}, repórtelo gracias.`, 'info');
        });
      }
    } catch (error) {
      console.error('Error al procesar la descarga:', error);
      swal('Error', 'Ha ocurrido un error al procesar la descarga. Por favor, inténtelo de nuevo.', 'error');
    }
  };

  // Si no hay datos suficientes, muestra un mensaje de carga
  if (!estadoAlumno || !testSemanales) {
    return (
      <div className="repaso-loading">
        <div className="loading-spinner"></div>
        <p>Cargando modo repaso...</p>
      </div>
    );
  }

  // Si el alumno no ha llegado al mes 6, mostrar mensaje explicativo
  if (estadoAlumno.mesesPagados < 6) {
    return <ExplicativoPanel />;
  }

  // Si no hay tests disponibles, muestra un mensaje
  if (testSemanales.length === 0) {
    return (
      <div className="repaso-no-tests">
        <i className="fas fa-info-circle no-tests-icon"></i>
        <h3>No hay tests disponibles</h3>
        <p>Actualmente no hay tests disponibles en el sistema de repaso.</p>
      </div>
    );
  }

  // Renderiza el contenido principal del modo repaso
  return (
    <div className="repaso-automatico">
      {/* Panel superior con información del repaso */}
      <InfoPanel 
        temaActual={temaActual} 
        semanaRepaso={semanaRepaso} 
        vueltasCompletadas={vueltasCompletadas} 
      />

      {/* Sistema de pestañas */}
      <TabPanel 
        tabs={tabs} 
        activeTab={activeTab} 
        setActiveTab={setActiveTab} 
      />

      {/* Contenido de las pestañas */}
      <div className="repaso-content">
        {/* Pestaña "Esta semana" */}
        {activeTab === "esta-semana" && (
          <TabContentEstaSemana 
            testsDestacados={testsDestacados} 
            temaActual={temaActual} 
            onDescargarTest={handleDescargarTest} 
          />
        )}

        {/* Pestaña "Todos los tests" */}
        {activeTab === "todos-tests" && (
          <TabContentTodosTests 
            testsRepaso={testsRepaso}
            testsGenerales={testsGenerales}
            filteredTests={filteredTests}
            inicioNumeracion={inicioNumeracion}
            finNumeracion={finNumeracion}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            handleOnClic={handleOnClic}
            onDescargarTest={handleDescargarTest}
          />
        )}

        {/* Pestaña "Planificación" */}
        {activeTab === "planificacion" && (
          <TabContentPlanificacion 
            temaActual={temaActual} 
            vueltasCompletadas={vueltasCompletadas} 
          />
        )}
      </div>

      {/* Footer con recursos adicionales */}
      <div className="repaso-footer">
        <p>
          <i className="fas fa-info-circle"></i> Recuerda practicar regularmente para obtener mejores resultados.
        </p>
      </div>
    </div>
  );
};

export default RepasoInformatica;